<template>
    <div>
        <div>
            <div id="hello-hello">
                <p style="display:inline;float: left;line-height: 22px;"><b>客户列表</b></p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-button round @click="download">下载模板</el-button>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin:5px 0">
                    <el-upload action="#" :http-request="uploadFile" :show-file-list="false">
                        <el-button round type="primary">批量导入</el-button>
                        <span>-</span>
                    </el-upload>
                </p>

                <p style="display:inline;float: right;line-height: 40px;margin: 5px 0;">
                    <el-button round type="primary" @click="openDialog">新增客户</el-button>
                    <span>-</span>
                </p>

                <div style="display:inline-block">
                    <el-radio-group v-model="typeSearch" @input="searchByType">
                        <el-radio-button label="1">已成交</el-radio-button>
                        <el-radio-button label="0">开发中</el-radio-button>
                    </el-radio-group>
                </div>

                <div style="display:inline-block;width: 300px;">
                    <el-input placeholder="请输入名称" v-model="queryValue" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="searchCustomer"></el-button>
                    </el-input>
                </div>

            </div>

            <el-table :data="customerList" style="width: 100%" tooltip-effect="dark">
                <el-table-column type="index" width="40" fixed>
                </el-table-column>

                <!-- <el-table-column prop="customerType" label="客户类型" min-width="10%" fixed>
                </el-table-column> -->
                <el-table-column prop="customerAbbrev" label="客户简称" min-width="15%" fixed>
                </el-table-column>
                <el-table-column prop="customerFullName" label="客户全称" min-width="25%" fixed>
                </el-table-column>

                <el-table-column prop="statusDes" label="状态" width="70">
                    <template slot="header">
                        <el-tooltip class="item" effect="light" placement="top" content="状态：禁用、启用">
                            <span>状态</span>
                        </el-tooltip>
                    </template>
                </el-table-column>

                <el-table-column prop="maker" label="创建人" min-width="10%">
                </el-table-column>
                <el-table-column prop="createdTime" label="创建时间" width="110">
                </el-table-column>

                <el-table-column fixed="right" label="操作" width="235">
                    <template slot-scope="scope">
                        <el-button @click="bindClick(scope.row)" type="success" round size="small"
                            v-if="scope.row.customerType == 0 ? false : true">
                            绑定员工
                        </el-button>
                        <el-button @click="handleClick(scope.row)" type="success" round size="small"
                            v-if="scope.row.customerType == 0 ? false : true">
                            编辑
                        </el-button>
                        <el-button @click="dealClick(scope.row)" type="success" round size="small"
                            v-if="scope.row.customerType == 0 ? true : false">
                            成交
                        </el-button>
                        <el-button @click="deleteClick(scope.row)" type="danger" round size="small" v-if="scope.row.customerType == 0 ? true : false">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div>
                <el-pagination background :page-size="cusPageNum" :page-count="cusPageCount"
                    layout="total, sizes, prev, pager, next" :total="cusTotal" @current-change="cusPageClick"
                    :page-sizes="[5, 10, 15, 20]" @size-change="hdlSizeChange">
                </el-pagination>
            </div>

            <el-dialog title="客户详情" :visible.sync="dialogVisible" width="50%">
                <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm" label-width="110px">

                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="客户类型" required prop="customerType">
                                <el-select v-model="form.customerType" placeholder="请选择" style="width:200px">
                                    <el-option v-for="item in cusTypeList" :key="item.value" :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="客户简称" required prop="customerAbbrev">
                                <el-input v-model="form.customerAbbrev" autocomplete="off"
                                    style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="客户全称" required prop="customerFullName">
                                <el-input v-model="form.customerFullName" autocomplete="off"
                                    style="width:400px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="业务联系人">
                                <el-input v-model="form.businessContacts" autocomplete="off"
                                    style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="业务电话">
                                <el-input v-model="form.businessPhone" autocomplete="off"
                                    style="width:400px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="业务联系地址">
                                <el-input v-model="form.businessAddress" autocomplete="off"
                                    style="width:760px;margin-right: 10px;"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="9">
                            <el-form-item label="仓库联系人" required>
                                <el-input v-model="form.warehouseContacts" autocomplete="off"
                                    style="width:200px"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="15">
                            <el-form-item label="仓库电话" required>
                                <el-input v-model="form.warehousePhone" autocomplete="off"
                                    style="width:400px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="仓库地址" required>
                                <el-input v-model="form.warehouseAddress" autocomplete="off"
                                    style="width:760px;margin-right: 10px;"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="addBaseCustomer('ruleForm')">保 存</el-button>
                </div>
            </el-dialog>

            <el-dialog title="员工绑定" :visible.sync="dlgTableVisible">
                <el-table :data="empList">
                    <el-table-column property="employeeName" label="姓名" width="200"></el-table-column>
                    <el-table-column property="phone" label="注塑号" width="150"></el-table-column>

                    <el-table-column property="customerAbbrev" label="客户" width="220"></el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="bindOrNoClick(scope.row)" type="text" size="small" style="color:green">{{
                        scope.row.customerUserId == null ? '绑定' : '取消绑定'
                    }}</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 分页 -->
                <div>
                    <el-pagination background :page-size="pageNum" :page-count="pageCount"
                        layout="total, sizes, prev, pager, next" :total="total" @current-change="pageClick"
                        :page-sizes="[8, 10, 12, 14]" @size-change="handleSizeChange">
                    </el-pagination>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import Sortable from 'sortablejs'

export default {
    name: "CustomerBase",
    data() {
        return {
            token: this.getToken(),
            userId: this.getUserId(),
            companyId: this.getCompanyId(),

            typeSearch: 1,
            // formLabelWidth: '120px',

            rules: {
                customerType: [
                    { required: true, message: '请选择客户类型', trigger: 'blur' },
                    { required: true, message: '请选择客户类型', trigger: 'change' }
                ],
                customerAbbrev: [
                    { required: true, message: '请输入客户简称', trigger: 'blur' },
                    { required: true, message: '请输入客户简称', trigger: 'change' }
                ],
                customerFullName: [
                    { required: true, message: '请输入客户全称', trigger: 'blur' },
                    { required: true, message: '请输入客户全称', trigger: 'change' }
                ]
            },

            dialogVisible: false,
            cusTypeList: [{
                id: 0,
                name: '开发中'
            }, {
                id: 1,
                name: '已成交'
            }],
            form: {
                customerId: '',
                customerAbbrev: '',

                customerFullName: '',

                customerType: '',
                
                businessContacts: '',
                businessPhone: '',
                businessAddress: '',

                warehouseContacts: '',
                warehousePhone: '',
                warehouseAddress: '',
            },
            customerList: [],
            queryValue: '',

            loading: false,

            cusPageIndex: 0,
            cusPageNum: 10,
            cusTotal: 0,
            cusPageCount: 0,

            dlgTableVisible: false,
            empList: [],

            pageIndex: 0,
            pageNum: 8,
            total: 0,
            pageCount: 0,

            contactDlgVisible: false,
            contactForm: {
                id: '',
                contacts: '',
                office: 0,
                telephone: '',
                address: '',

                officeList: [{
                    id: 0,
                    officeName: '业务员'
                }, {
                    id: 1,
                    officeName: '仓管员'
                }]
            },
            contactList: []
        }
    },
    methods: {
        searchByType(val) {
            this.pageIndex = 0
            this.cusTotal = 0
            //console.log('bbb')
            //console.log(val)
            this.getAllBaseCustomer()
        },
        download() {
            this.$axios({
                method: "get",
                url: "/shiro/base/customer/download",
                data: {},
                headers: {
                    token: this.token
                },
                responseType: 'arraybuffer'
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                let objectUrl = result.config.url
                const blob = new Blob([data], {
                    type: 'application/vnd.ms-excel;charset=utf-8'
                })

                objectUrl = URL.createObjectURL(blob)
                const a = document.createElement("a")
                a.href = objectUrl

                a.download = "客户资料导入模板.xlsx"
                a.click()
                a.remove()
                URL.revokeObjectURL(objectUrl)
            })
        },
        uploadFile(f) {
            const form = new FormData()

            form.append('uploadFile', f.file)
            form.append('companyId', this.companyId)
            form.append('userId', this.userId)

            this.$axios({
                method: "post",
                url: "/shiro/base/customer/upload",
                data: form,
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status == 201) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                }

                this.getAllBaseCustomer()
            })
        },
        searchCustomer(query) {
            this.customerList = []
            this.cusPageIndex = 0

            if (this.queryValue !== '') {
                this.loading = true

                setTimeout(() => {
                    this.loading = false
                    
                    this.getAllBaseCustomer()
                }, 200)
            } else {
                this.$message({
                    type: 'info',
                    message: '请输入搜索条件'
                })
            }
        },
        //行拖拽
        rowDrop() {
            const tbodys = document.querySelectorAll('.el-table__body tbody')//[8]
            // console.log(tbodys)
            const tbody = document.body.querySelector('.el-table__body tbody')
            // console.log('tbody')
            // console.log(tbody)
            const _this = this
            // console.log('_this')
            // console.log(_this)
            Sortable.create(tbody, {
                onEnd({ newIndex, oldIndex }) {
                    if (newIndex == oldIndex) return
                    _this.productList.splice(newIndex, 0, _this.productList.splice(oldIndex, 1)[0])
                    var newArray = _this.productList.slice(0)
                    // console.log('newArray')
                    // console.log(newArray)
                    _this.productList = []
                    _this.$nextTick(function () {
                        _this.productList = newArray
                        this.sort(newArray)
                    })
                }
            })
        },
        sort(val) {
            // console.log('sort()')
            const baseBOMInfoVOList = []
            this.$axios({
                method: "post",
                url: "/shiro/base/bom/sort",
                data: {
                    baseBOMInfoVOList: val,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }
            })
        },
        //根据客户id查询员工绑定情况
        getAllEmpCustomer() {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll/customerId",
                data: {
                    pageIndex: this.pageIndex,
                    pageNum: this.pageNum,
                    customerId: this.form.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.empList = data.data
                this.total = this.empList[0].total

                this.dlgTableVisible = true
            })
        },
        openDialog() {
            this.form.customerId = ''
            this.form.customerAbbrev = ''
            this.form.customerFullName = ''

            this.form.customerType = ''

            this.form.businessContacts = ''
            this.form.businessPhone = ''
            this.form.businessAddress = ''

            this.form.warehouseContacts = ''
            this.form.warehousePhone = ''
            this.form.warehouseAddress = ''

            this.dialogVisible = true
        },
        //绑定员工按钮点击事件
        bindClick(row) {
            this.form.customerId = row.customerId

            this.getAllEmpCustomer(row)
        },
        bindOrNoClick(row) {
            if (row.customerUserId == null) {
                this.bindEmp(row)
            } else {
                this.unBindEmp(row)
            }
        },
        bindEmp(row) {
            this.$axios({
                method: "post",
                url: "/shiro/employee/cus/bind",
                data: {
                    userId: row.userId,
                    customerId: this.form.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.getAllEmpCustomer()
            })
        },
        unBindEmp(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/employee/cus/unBind",
                data: {
                    customerUserId: row.customerUserId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {
                this.$message({
                    type: 'success',
                    message: result.data.msg
                })

                this.getAllEmpCustomer()
            })
        },
        handleClick(row) {
            //根据用户id确定是否有编辑当前客户资料的权限
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getByUser",
                data: {
                    userId: this.userId,
                    customerId: row.customerId,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.form.customerId = data.data.customerId

                this.form.customerType = data.data.customerType

                this.form.customerAbbrev = data.data.customerAbbrev
                this.form.customerFullName = data.data.customerFullName

                this.form.businessContacts = data.data.businessContacts
                this.form.businessPhone = data.data.businessPhone
                this.form.businessAddress = data.data.businessAddress

                this.form.warehouseContacts = data.data.warehouseContacts
                this.form.warehousePhone = data.data.warehousePhone
                this.form.warehouseAddress = data.data.warehouseAddress

                this.dialogVisible = true

                // this.getCusContact()
            })

        },
        dealClick(row) {
            this.$confirm('确定已成交了吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.$axios({
                    method: "post",
                    url: "/shiro/base/customer/modify",
                    data: {
                        userId: this.userId,
                        customerId: row.customerId,
                        customerType: 1,
                        companyId: this.companyId
                    },
                    headers: {
                        token: this.token
                    }
                }).then(result => {

                    const data = result.data

                    if (data.status != 200) {
                        this.$message({
                            type: 'info',
                            message: data.msg
                        })
                        return
                    }

                    this.getAllBaseCustomer()
                })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                })
            })

        },
        deleteClick(row) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                this.removeBaseCus(row)

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        },
        removeBaseCus(row) {
            this.$axios({
                method: "delete",
                url: "/shiro/base/customer/remove",
                data: {
                    customerId: row.customerId,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {
                const data = result.data

                this.$message({
                    type: 'success',
                    message: data.msg
                })

                this.getAllBaseCustomer()
            })
        },
        addBaseCustomer(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    const form = new FormData()

                    form.append('customerId', this.form.customerId)

                    form.append('customerAbbrev', this.form.customerAbbrev)
                    form.append('customerFullName', this.form.customerFullName)

                    form.append('customerType', this.form.customerType)

                    form.append('businessAddress', this.form.businessAddress)
                    form.append('businessContacts', this.form.businessContacts)
                    form.append('businessPhone', this.form.businessPhone)
                    form.append('warehouseAddress', this.form.warehouseAddress)
                    form.append('warehouseContacts', this.form.warehouseContacts)
                    form.append('warehousePhone', this.form.warehousePhone)

                    form.append('maker', this.userId)
                    form.append('companyId', this.companyId)

                    this.$axios({
                        method: "post",
                        url: "/shiro/base/customer/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message({
                                type: 'info',
                                message: data.msg
                            })
                            return
                        }

                        this.dialogVisible = false
                        this.getAllBaseCustomer()
                    })
                }
            })
        },
        getAllBaseCustomer() {
            this.$axios({
                method: "post",
                url: "/shiro/base/customer/getAll",
                data: {
                    pageIndex: this.cusPageIndex,
                    pageNum: this.cusPageNum,
                    queryParam: this.queryValue,
                    typeStr: this.typeSearch,
                    companyId: this.companyId
                }, headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.customerList = data.data
                this.cusTotal = this.customerList[0].total
                for (let i in this.customerList) {
                    this.customerList[i].createdTime = this.$moment(this.customerList[i].createdTime).format("YYYY-MM-DD")

                    if (this.customerList[i].status == 1) {
                        this.customerList[i].statusDes = '启用'
                    } else {
                        this.customerList[i].statusDes = '禁用'
                    }

                }
            })
        },
        cusPageClick(currentPage) {
            this.customerList = []

            this.cusPageIndex = (currentPage - 1) * this.cusPageNum

            this.getAllBaseCustomer()
        },
        hdlSizeChange(val) {
            this.cusPageNum = val

            this.getAllBaseCustomer()
        },
        //绑定员工分页查询
        pageClick(currentPage) {
            this.empList = []

            this.pageIndex = (currentPage - 1) * this.pageNum

            this.getAllEmpCustomer()
        },
        handleSizeChange(val) {
            this.pageNum = val

            this.getAllEmpCustomer()
        },
        openContactDlg() {
            if (this.form.customerId == '') {
                this.$message({
                    type: 'info',
                    message: '请点击编辑按钮，选择客户'
                })
                return
            }

            this.contactForm.id = ''

            this.contactForm.office = ''
            this.contactForm.address = ''
            this.contactForm.contacts = ''
            this.contactForm.telephone = ''

            this.contactDlgVisible = true
        },
        // addCusContact() {
        //     this.$axios({
        //         method: "post",
        //         url: "/shiro/customer/contacts/add",
        //         data: {
        //             id: this.contactForm.id,
        //             customerId: this.form.customerId,
        //             contacts: this.contactForm.contacts,
        //             office: this.contactForm.office,
        //             telephone: this.contactForm.telephone,
        //             address: this.contactForm.address,
        //             maker: this.userId,
        //             companyId: this.companyId
        //         },
        //         headers: {
        //             token: this.token
        //         }
        //     }).then(result => {

        //         const data = result.data

        //         if (data.status != 200) {
        //             this.$message({
        //                 type: 'info',
        //                 message: data.msg
        //             })
        //             return
        //         }

        //         this.contactDlgVisible = false
        //         this.getCusContact()
        //     })
        // },
        // getCusContact() {
        //     this.$axios({
        //         method: "post",
        //         url: "/shiro/customer/contacts/getAll",
        //         data: {
        //             customerId: this.form.customerId,
        //             companyId: this.companyId
        //         }, headers: {
        //             token: this.token
        //         }
        //     }).then(result => {

        //         const data = result.data

        //         if (data.status === 400) {
        //             this.$router.push({ path: "/Login" })
        //         }

        //         if (data.status != 200) {
        //             this.$message({
        //                 type: 'info',
        //                 message: data.msg
        //             })
        //             return
        //         }

        //         this.contactList = data.data
        //         for (let i in this.contactList) {
        //             if (this.contactList[i].office == 0) {
        //                 this.contactList[i].officeStr = '业务员'
        //             } else if (this.contactList[i].office == 1) {
        //                 this.contactList[i].officeStr = '仓管员'
        //             }
        //         }
        //     })
        // },
        // contactHdlClick(row) {

        //     this.contactForm.id = row.id
        //     this.contactForm.contacts = row.contacts
        //     this.contactForm.office = row.office
        //     this.contactForm.telephone = row.telephone
        //     this.contactForm.address = row.address

        //     this.contactDlgVisible = true
        // },
        // delContactClick(row) {
        //     this.$confirm('确定要删除吗?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {

        //         this.removeCusContact(row)

        //     }).catch(() => {
        //         this.$message({
        //             type: 'info',
        //             message: '已取消删除'
        //         });
        //     })
        // },
        // removeCusContact(row) {
        //     this.$axios({
        //         method: "delete",
        //         url: "/shiro/customer/contacts/remove",
        //         data: {
        //             id: row.id,
        //             companyId: this.companyId
        //         },
        //         headers: {
        //             token: this.token
        //         }
        //     }).then(result => {
        //         const data = result.data

        //         this.$message({
        //             type: 'success',
        //             message: data.msg
        //         });

        //         // this.getCusContact()
        //     })
        // }
    },
    mounted() {
        this.setDefaultPath('/customerBase')

        // 阻止默认行为
        document.body.ondrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
        };
        this.rowDrop()//行拖拽

        this.getAllBaseCustomer()
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}
</style>